import Vue from 'vue/dist/vue.esm.js';
import * as bootstrap from "bootstrap";
import {formatPrice} from '../utility/formatPrice'
import {parseCartResponse, serializeCartForEvent} from '../utility/parseCartResponse'

Vue.component('checkout', {
    template: `#checkout`,
    delimiters: ['[[', ']]'],
    props: {
        initialCart: {
            required: true,
            type: Object,
        },
        delivery: {
            required: true,
            type: Array,
        },
        deliveryOptions: {
            required: true,
            type: Array,
        },
        locale: {
            required: true,
            type: String,
        },
        currency: {
            required: true,
            type: String,
        },
        removeRowUrl: {
            required: true,
            type: String,
        },
        fetchBoxNowPlacesUrl: {
            required: true,
            type: String,
        },
        fetchClickAndCollectPharmaciesUrl: {
            required: true,
            type: String,
        },
        fetchSpeedyPlacesUrl: {
            required: true,
            type: String,
        },
        fetchSamedayPlacesUrl: {
            required: false,
            type: String,
            default: '',
        },
        fetchEcontPlacesUrl: {
            required: false,
            type: String,
            default: '',
        },
        fetchEcontCitiesUrl: {
            required: false,
            type: String,
            default: '',
        },
        validateEcontAddressUrl: {
            required: false,
            type: String,
            default: '',
        },
        incrementUrl: {
            required: true,
            type: String,
        },
        decrementUrl: {
            required: true,
            type: String,
        },
        promocodeUrl: {
            required: true,
            type: String,
        },
        removePromocodeUrl: {
            required: true,
            type: String,
        },
        invoiceUrl: {
            required: true,
            type: String,
        },
        fetchOfficesUrl: {
            required: true,
            type: String,
        },
        uniqueEventId: {
            required: false,
            type: String,
        },
        freeDeliveryOver: {
            required: true,
            type: Number,
        },
        freeDeliveryOverGlovo: {
            required: true,
            type: Number,
            default: 0,
        },
        cashOnDeliveryFee: {
            required: true,
            type: Number,
        },
        cashOnDeliveryMaxAmount: {
            required: false,
            type: Number,
            default: 0,
        },
        hasUser: {
            required: true,
            type: Number,
        },
        userAddresses: {
            required: false,
            type: Array,
        },
        userCards: {
            required: false,
            type: Array,
        },
        googleMapsApiKey: {
            required: true,
            type: String
        },
        exchangeRate: {
            required: true,
            type: String,
        },
        exchangeRateMode: {
            required: true,
            type: String,
        },
        convertMode: {
            required: true,
            type: String,
        },
        showEurFirst: {
            required: false,
            type: String,
            default: '0'
        },
        holidays: {
            required: false,
            type: String
        },
        dayOffsBySlug: {
            required: false,
            type: String,
            default: '{}'
        },
        glovoClientId: {
            required: false,
            type: String
        },
        glovoClientSecret: {
            required: false,
            type: String
        },        
        glovoDebugDatetime: {
            required: false,
            type: String,
            default: '',
        },
    },

    data() {
        return {
            types: this.delivery,
            options: this.deliveryOptions,
            cart: this.initialCart,
            initialFreeDeliveryOver: this.freeDeliveryOver,
            initialCashOnDeliveryFee: this.cashOnDeliveryFee,
            freeDeliveryAmount: this.freeDeliveryOver,
            showPromocode: false,
            hasPromocode: !!this.initialCart.promocode,
            promocode: this.initialCart.promocode,
            promocodeText: null,
            promocodeError: null,
            selectedType: null,
            selectedDate: null,
            selectedOption: null,
            selectedPackage: null,
            selectedSlot: null,
            selectedCity: null,
            selectedUserAddress: null,
            selectedPaymentMethod: null,
            selectedOffice: null,
            selectedClickAndCollectPharmacy: null,
            prevSelectedPaymentMethod: null,
            selectedCard: null,
            allowNewAddress: 0,
            deliveryPrice: null,
            deliveryPriceDiscount: null,
            haveInvoice: 0,
            saveAddress: 0,
            isSlotSelecting: false,
            offices: {},
            officesPage: 0,
            needShowMap: false,
            placeLng: null,
            placeLat: null,
            searchTerm: null,
            loadingOffices: false,
            isMapInitiated: false,
            autocompleteInstances: {},
            needShowMoreButton: false,
            // packages: this.packageOptions,
            quantityAlert: {
                visible: false,
                productName: '',
            },
            noOfficesWarning: false,
            econtAddressError: null,
            econtAddressValidating: false,
            econtAddressValidatedKey: null,
            econtAddressRequest: null,
            econtAddressRequestId: 0,
            errors: {
                type: false,
                option: false,
                payment: false,
                userAddress: false,
            },
            registerMe: false,
            locationError: null,
            addressValue: '',
            glovoAddress: '',
            glovoAutocompleteInstance: null,
            glovoAddressDetails: null,
            samedayLocationIds: '',
            samedayCityName: '',
            samedayPostalCode: '',
            streetNumber: '',
            addressDetails: '',
            showOutOfWorkingHoursMessage: false,
            showClickAndCollectDeliveryHint: false,
            showClickAndCollectSofiaHint: false,
            lat: null,
            lng: null,
        }
    },

    mounted() {

        this.showLoginModal();

        let _self = this;
        let select2City = $(this.$refs.cityField);
        select2City.on('change', function (e) {
            _self.changeUserData();
        });

        $(document).on('select2:open', function (e) {
            document.querySelector(`[aria-controls="select2-${e.target.id}-results"]`).focus();
        });

        //TODO add step 1 and step 2 default value "not a gift"
        this.initHaveInvoice();
        this.initRegisterMe();
        this.initSaveAddress();
        this.initAllowNewAddress();
        this.initSearchTerm();


        if (parseInt(this.$refs.existingAddress.dataset.val)) {
            this.selectUserAddress(this.userAddresses.filter(d => d.id === parseInt(this.$refs.existingAddress.dataset.val))[0]);
        }
        if (parseInt(this.$refs.selectedOption.dataset.val)) {

            this.selectDeliveryOption(this.deliveryOptions.filter(d => d.id === parseInt(this.$refs.selectedOption.dataset.val))[0]);

        }

        if (parseInt(this.$refs.selectedOffice.dataset.val)) {
            this.selectOffice(parseInt(this.$refs.selectedOption.dataset.val));
        }


        if (parseInt(this.$refs.selectedPaymentMethod.dataset.val)) {
            this.selectPaymentMethod(this.selectedOption.paymentMethods.filter(d => d.id === parseInt(this.$refs.selectedPaymentMethod.dataset.val))[0]);
        }

        if (parseInt(this.$refs.selectedCard.dataset.val)) {
            this.selectCard(this.userCards.filter(d => d.id === parseInt(this.$refs.selectedCard.dataset.val))[0]);
        }

        if (this.$refs.cityField && this.$refs.cityField.value) {
            this.selectedCity = this.$refs.cityField.value;
        }

        if (this.$refs.cityValue && this.$refs.cityValue.value) {
            this.selectedCity = this.$refs.cityValue.value;
        }

        EventManager.listen('item-added', this.cartUpdated);
        EventManager.listen('cart-updated', this.cartUpdated);
        EventManager.listen('order-address:city', this.cityChanged);
        EventManager.listen('item-removed', this.cartUpdated);

        this.$nextTick(() => {
            this.updateClickAndCollectDeliveryHint();
        });
    },


    methods: {
        getGlovoNow() {
            if (this.glovoDebugDatetime) {
                const debugDate = new Date(this.glovoDebugDatetime.replace(' ', 'T'));
                if (!Number.isNaN(debugDate.getTime())) {
                    return debugDate;
                }
            }

            return new Date();
        },
            formatDualPrice(price) {
                return formatPrice(price, this.exchangeRate, this.exchangeRateMode, this.convertMode, true, this.showEurFirst);
            },
            formatGlovoAddress(place) {
                const getComponent = (type) => {
                    const comp = place.address_components?.find(c => c.types.includes(type));
                    return comp ? comp.long_name : '';
                };

                const streetName = getComponent('route');
                const streetNumber = getComponent('street_number');
                const postalCode = getComponent('postal_code');
                const cityName = getComponent('locality') || getComponent('administrative_area_level_1');

                const parts = [];
                if (streetName) parts.push(streetName);
                if (streetNumber) parts.push(streetNumber);
                if (postalCode) parts.push(postalCode);
                if (cityName) parts.push(cityName);

                return parts.join(', ');
            },
            getUserLocation(url) {
            if (navigator.geolocation) {
                this.loadingOffices = true;
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        this.placeLat = position.coords.latitude;
                        this.placeLng = position.coords.longitude;
                        this.locationError = null;
                        this.loadingOffices = true;

                        const geocoder = new google.maps.Geocoder();
                        geocoder.geocode({location: {lat: position.coords.latitude, lng: position.coords.longitude}}, (results, status) => {
                            if (status === 'OK' && results.length > 0) {
                                const place = results[0];
                                if (this.selectedOption.id === 5) {
                                    this.searchTerm = this.formatGlovoAddress(place);
                                } else {
                                    this.searchTerm = place.formatted_address;
                                }
                                this.officesPage = 0;
                                if (this.selectedOption?.id === 1) {
                                    this.selectedClickAndCollectPharmacy = null;
                                }
                                if (this.selectedOption?.id === 5) {
                                    this.loadingOffices = false;
                                } else if (url) {
                                    this.fetchPlaces(url, this.placeLat, this.placeLng, 1);
                                } else {
                                    this.loadingOffices = false;
                                }

                                if (this.selectedOption.id === 5) {
                                    const place = results[0];
                                    const getComponent = (type) => {
                                        const comp = place.address_components?.find(c => c.types.includes(type));
                                        return comp ? comp.long_name : '';
                                    };

                                    this.glovoAddressDetails = {
                                        cityName: getComponent('locality') || getComponent('administrative_area_level_1'),
                                        country: getComponent('country'),
                                        postalCode: getComponent('postal_code'),
                                        rawAddress: this.searchTerm || '',
                                        details: '', // free-form notes if needed
                                        streetName: getComponent('route'),
                                        streetNumber: getComponent('street_number'),
                                        coordinates: {
                                            latitude: position.coords.latitude || null,
                                            longitude: position.coords.longitude || null
                                        }
                                    };

                                    this.lat = position.coords.latitude || null;
                                    this.lng = position.coords.longitude || null;
                                }
                            } else {
                                console.warn('Geocoder failed due to:', status);
                                this.loadingOffices = false;
                            }
                        });

                    },
                    (error) => {
                        this.locationError = "Не успяхме да извлечем твоето местоположение";
                        console.warn(error.message);
                        this.loadingOffices = false;
                    },
                    {
                        timeout: 3000,
                    }
                );
            } else {
                this.locationError = "Не успяхме да извлечем твоето местоположение";
            }
        },

        destroyAllInstances() {
            Object.keys(this.autocompleteInstances).forEach((elementId) => {
                const instance = this.autocompleteInstances[elementId];
                if (instance) {
                    google.maps.event.clearInstanceListeners(elementId);
                    instance.unbindAll();
                }
            });
            this.autocompleteInstances = {};

        },

        needShowMapMethod(id) {
            return this.needShowMap === id;
        },

        async showMap(lat, lng, id) {
            this.needShowMap = id;
            this.$nextTick(() => {
                GoogleApiUtility.InitMapWithMarker(lat, lng);
            });

        },

        // This function will be called by the Google Maps API callback
        initGoogleMapsApiAutocomplete(element, url) {

            if (!element) {
                console.error("Input element not found");
                return;
            }

            this.destroyAllInstances();

            const autocomplete = new google.maps.places.Autocomplete(element, { componentRestrictions: { country: ['bg'] } });
            autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace();
                if (this.selectedOption.id === 5) {
                    this.searchTerm = this.formatGlovoAddress(place);
                } else {
                    this.searchTerm = place.formatted_address;
                }
                if (!place) return;
                if (place.geometry) {
                    this.placeLat = place.geometry.location.lat();  // Latitude
                    this.placeLng = place.geometry.location.lng();  // Longitude
                    this.locationError = null;
                    this.officesPage = 0;
                    if (this.selectedOption?.id === 1) {
                        this.selectedClickAndCollectPharmacy = null;
                    }
                    if (this.selectedOption?.id === 5) {
                        this.loadingOffices = false;
                    } else if (url) {
                        this.loadingOffices = true;
                        this.fetchPlaces(url, this.placeLat, this.placeLng, ++this.officesPage);
                    }
                }

                if (this.selectedOption?.id === 5) {
                    const getComponent = (type) => {
                        const comp = place.address_components?.find(c => c.types.includes(type));
                        return comp ? comp.long_name : '';
                    };

                    this.glovoAddressDetails = {
                        cityName: getComponent('locality') || getComponent('administrative_area_level_1'),
                        country: getComponent('country'),
                        postalCode: getComponent('postal_code'),
                        rawAddress: this.searchTerm || place.formatted_address || place.name || '',
                        details: '',
                        streetName: getComponent('route'),
                        streetNumber: getComponent('street_number'),
                        coordinates: {
                            latitude: place.geometry?.location?.lat() || null,
                            longitude: place.geometry?.location?.lng() || null
                        }
                    };

                    this.lat = place.geometry?.location?.lat() || null;
                    this.lng = place.geometry?.location?.lng() || null;
                }
            });
            this.$set(this.autocompleteInstances, element, autocomplete);

            return autocomplete;
        },

        fetchPlaces(url, lat, lng, page) {
                console.log("page", page);
            this.needShowMoreButton = false;
            let _self = this;
            $.ajax({
                data: {lat: lat, lng: lng, page: page},  // Pass lat and lng, not the entire geometry object
                url: url,
                method: 'POST',
                success: function (result) {
                    _self.offices = result.results;
                    _self.officesPage = result.page;
                    _self.needShowMoreButton = result.maxResults > result.resultsPerPage * result.page;

                    _self.loadingOffices = false;

                    // Handle result from server if necessary
                },
                error: function (error) {
                    _self.loadingOffices = false;
                    console.error("Error fetching data:", error);
                }
            });
        },

        getDeliveryTypeImage(option) {
            if (option.slug === 'sameday_delivery_to_locker') {
                return '/uploads/images/couriers/easybox.svg';
            }

            if (option.slug === 'glovo_on_demand') {
                return '/uploads/images/couriers/glovo.svg';
            }

            return option.courier.image ? option.courier.image : '';
        },

        initHaveInvoice() {
            let value;
            if (this.validateRef("haveInvoice")) {
                if (isNaN(parseInt(this.$refs.haveInvoice.dataset.val))) {
                    value = null;
                } else {
                    value = parseInt(this.$refs.haveInvoice.dataset.val);
                }
            }
            this.haveInvoice = value;

            if (this.haveInvoice === 1) {
                this.changeInvoice();
            }
        },

        initSearchTerm() {
            let value;
            if (this.validateRef("searchTerm")) {
                if (this.$refs.searchTerm.dataset.val === '') {
                    value = null;
                } else {
                    value = this.$refs.searchTerm.dataset.val;
                }
            }
            this.searchTerm = value;
        },

        showLoginModal() {

            if (this.hasUser) {
                return;
            }
            const loginModalKey = 'lastLoginModalShown';
            const now = Date.now();
            const thirtyMinutes = 30 * 60 * 1000;

            const lastShown = localStorage.getItem(loginModalKey);
            if (!lastShown || (now - lastShown > thirtyMinutes)) {
                const loginModal = new bootstrap.Modal(document.getElementById('checkout-modal'));
                loginModal.show();
                localStorage.setItem(loginModalKey, now);
            }
        },
        initRegisterMe() {
            let value;
            if (this.validateRef("registerMe")) {
                if (isNaN(parseInt(this.$refs.registerMe.dataset.val))) {
                    value = null;
                } else {
                    value = parseInt(this.$refs.registerMe.dataset.val);
                }
            }
            this.registerMe = value;
        },
        initSaveAddress() {
            let value;
            if (this.validateRef("saveAddress")) {
                if (this.$refs.saveAddress.dataset.val === '') {
                    return;
                }
                if (isNaN(parseInt(this.$refs.saveAddress.dataset.val))) {
                    value = null;
                } else {
                    value = parseInt(this.$refs.saveAddress.dataset.val);
                }
            }
            this.saveAddress = value;
        },
        initAllowNewAddress() {
            let value = this.allowNewAddress;
            if (this.validateRef("allowNewAddress")) {
                if (this.$refs.allowNewAddress.dataset.val === '') {
                    return;
                }
                if (isNaN(parseInt(this.$refs.allowNewAddress.dataset.val))) {
                    value = null;
                } else {
                    value = parseInt(this.$refs.allowNewAddress.dataset.val);
                }
            }
            this.allowNewAddress = value;
        },

        validateRef(ref) {
            if (this.$refs[ref] !== undefined) {
                return true;
            }
            return false;
        },

        async selectOffice(office){
            this.selectedOffice = office;
            if (this.selectedOption?.slug === 'sameday_delivery_to_locker') {
                if (office?.locationIds) {
                    this.samedayLocationIds = office.locationIds;
                }
                this.samedayPostalCode = office?.postalCode ?? '';
            }
            this.$nextTick(() => this.syncCheckoutHiddenFields());
        },

        isOfficePickerSlug(slug) {
            return [
                'click_and_collect',
                'boxnow_delivery_to_station',
                'speed_delivery_to_office',
                'sameday_delivery_to_locker',
                'econt_delivery_to_office',
                'glovo_on_demand',
            ].includes(slug);
        },

        getGlovoAutocompleteField() {
            const ref = this.$refs.glovoAutoCompletedField;
            if (Array.isArray(ref)) {
                return ref.find(el => el) || null;
            }
            return ref || null;
        },

        initGlovoAutocompleteField() {
            const field = this.getGlovoAutocompleteField();
            if (!field) {
                return;
            }
            this.initGoogleMapsApiAutocomplete(field, null);
        },

        getClickAndCollectSelect() {
            const ref = this.$refs.clickAndCollectPlace;

            if (Array.isArray(ref)) {
                return ref.find((element) => element) || null;
            }

            return ref || this.$el?.querySelector('select[name="order[orderAddress][clickAndCollectPlace]"]') || null;
        },

        selectClickAndCollectPharmacy(pharmacy) {
            this.selectedClickAndCollectPharmacy = pharmacy;

            const select = this.getClickAndCollectSelect();
            if (select) {
                select.innerHTML = '';
                const option = document.createElement('option');
                option.value = pharmacy.id;
                option.text = pharmacy.name;
                option.selected = true;
                select.appendChild(option);
            }

            this.updateClickAndCollectDeliveryHint();
        },

        async selectDeliveryOption(option) {
            this.errors.userAddress = false;
            if (this.selectedOption === option) {
                return;
            }

            this.searchTerm = null;
            this.errors.type = false;
            this.selectedOption = option;

            this.noOfficesWarning = false;
            this.resetEcontAddressValidation();
            this.needShowMoreButton = false;
            this.selectedCity = null;
            this.selectedPaymentMethod = null;
            this.selectedCard = null;
            this.selectedType = option.deliveryType

            this.deliveryPrice = option.price;

            //hackfix for hiding select2
            if (!this.selectedType.id !== 3) {
                if (this.$refs.officeField) {
                    $(this.$refs.officeField).select2('destroy');
                }
            }

            this.offices = {};
            this.officesPage = 0;
            this.selectedClickAndCollectPharmacy = null;
            this.samedayLocationIds = '';
            this.samedayPostalCode = '';
            this.samedayCityName = '';


            if (this.isOfficePickerSlug(option.slug)) {
                this.selectedOffice = null;
                try {
                    await GoogleApiUtility.LoadGoogleMapsScript(this.googleMapsApiKey);
                } catch (error) {
                    console.error("Error loading Google Maps script:", error);
                }
            }

            if (option.slug === 'click_and_collect') {
                this.$nextTick(() => {
                    const field = Array.isArray(this.$refs.clickAndCollectAutoCompletedField)
                        ? this.$refs.clickAndCollectAutoCompletedField[0]
                        : this.$refs.clickAndCollectAutoCompletedField;
                    this.initGoogleMapsApiAutocomplete(field, this.fetchClickAndCollectPharmaciesUrl);
                    this.updateClickAndCollectDeliveryHint();
                });
            } else if (option.slug === 'boxnow_delivery_to_station') {
                this.$nextTick(() => {
                    this.initGoogleMapsApiAutocomplete(this.$refs.boxnowAutoCompletedField[0], this.fetchBoxNowPlacesUrl);

                });
            } else if (option.slug === 'speed_delivery_to_office') {
                this.$nextTick(() => {
                    this.initGoogleMapsApiAutocomplete(this.$refs.speedyAutoCompletedField[0], this.fetchSpeedyPlacesUrl);
                });
            } else if (option.slug === 'sameday_delivery_to_locker') {
                this.$nextTick(() => {
                    this.initGoogleMapsApiAutocomplete(this.$refs.samedayAutoCompletedField[0], this.fetchSamedayPlacesUrl);
                });
            } else if (option.slug === 'econt_delivery_to_office') {
                this.$nextTick(() => {
                    this.initGoogleMapsApiAutocomplete(this.$refs.econtAutoCompletedField[0], this.fetchEcontPlacesUrl);
                });
            } else if (option.slug === 'glovo_on_demand') {
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.initGlovoAutocompleteField();
                    });
                });

                const now = this.getGlovoNow();
                const hour = now.getHours();
                const minutes = now.getMinutes();

                this.showOutOfWorkingHoursMessage = (hour <= 8 && minutes <= 30) || (hour >= 16 && minutes > 20);
            } else if (option.slug === 'speed_delivery_to_address'
                || option.slug === 'econt_delivery_to_address'
                || option.slug === 'sameday_delivery_to_address') {
                this.$nextTick(() => {
                    this.ensureOrderCitySelect2();
                    this.updateAddressPlaceholder(option.slug);
                });
            } else {
                this.updateAddressPlaceholder(null);
            }

            this.needShowMap = false;

            let addShippingInfo = {
                event: 'add_shipping_info',
                cart: this.cart,
                eventData: this.selectedType,
            }

            if (option.id !== 1) {
                this.showClickAndCollectDeliveryHint = false;
                this.showClickAndCollectSofiaHint = false;
            }

            EventManager.fire('gtm-event', addShippingInfo);
        },
        updateClickAndCollectDeliveryHint() {
            const sofiaCityId = 4389;
            const cityId = parseInt(this.selectedClickAndCollectPharmacy?.city_id, 10);

            this.showClickAndCollectDeliveryHint = !!cityId && cityId !== sofiaCityId;
            this.showClickAndCollectSofiaHint = !!cityId && cityId === sofiaCityId;
        },
        changeUserData() {
            // let eventStep5 = {
            //     event: 'eec.checkout',
            //     eventData: "customer details",
            //     action: 5,
            // }
            // EventManager.fire('gtm-event', eventStep5);
        },

        ensureOrderCitySelect2() {
            const cityEl = this.$refs.cityField;
            if (!cityEl || typeof $.fn.select2entity !== 'function') {
                return;
            }

            const $city = $(cityEl);
            if (!$city.data('econtAddressCityBound')) {
                $city.on('change.econtAddressCity', () => this.validateEcontAddress());
                $city.data('econtAddressCityBound', true);
            }

            if ($city.hasClass('select2-hidden-accessible')) {
                return;
            }

            $city.select2entity();

            if (!$city.data('orderAddressCityBound')) {
                $city.on('select2:select.orderAddressCity', (e) => {
                    EventManager.fire('order-address:city', e.params.data.id);
                });
                $city.data('orderAddressCityBound', true);
            }
        },

        updateAddressPlaceholder(deliverySlug) {
            const el = this.$refs.orderAddressRaw;
            const field = el && el.length ? el[0] : el;
            if (!field) {
                return;
            }

            const econtPlaceholder = field.dataset.econtPlaceholder || '';
            field.placeholder = deliverySlug === 'econt_delivery_to_address' ? econtPlaceholder : '';
        },


        toggleOfficeInfo(office) {
            this.offices.forEach((item) => {
                item.active = item === office ? !item.active : false;
            });
        },

        selectUserAddress(address) {
            this.showPaymentTooltip();
            if (this.selectedUserAddress === address) {
                return;
            }
            this.errors.userAddress = false;
            this.selectedUserAddress = address;
            this.allowNewAddress = false;
            this.saveAddress = false & 1;

            this.saveAddress = 0;

            this.selectedType = address.type;
            // this.selectedArea = address.area;
            if (address.cityId) {
                this.selectedCity = address.cityId;
            }
            this.selectedOption = address.deliveryOption;
            this.deliveryPrice = address.deliveryOption.price;

            // this.initStep3(address.type);
            // this.initStep4(address.deliveryOption);
            this.changeUserData();

            let addShippingInfo = {
                event: 'add_shipping_info',
                cart: this.cart,
                eventData: address,
            }

            EventManager.fire('gtm-event', addShippingInfo);

        },
        removeOptions(selectElement, clearSelected = false) {
            if (!selectElement) {
                return;
            }

            let i, Length = selectElement.options.length - 1;
            for (i = Length; i >= 1; i--) {

                if (selectElement.options[i].selected == true && !clearSelected) {
                    continue;
                }

                selectElement.remove(i);

            }
        },

        async postData(url = '', data = {}) {
            // Default options are marked with *
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                mode: 'cors', // no-cors, *cors, same-origin
                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'same-origin', // include, *same-origin, omit
                headers: {
                    'Content-Type': 'application/json'
                    // 'Content-Type': 'application/x-www-form-urlencoded',
                },
                redirect: 'follow', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: JSON.stringify(data) // body data type must match "Content-Type" header
            });
            return response.json(); // parses JSON response into native JavaScript objects
        },
        showPaymentTooltip() {
            // $('[data-toggle="tooltip"]').tooltip();
        },
        selectPaymentMethod(paymentMethod) {
            // let eventStep6 = {
            //     event: 'eec.checkout',
            //     eventData: paymentMethod.method,
            //     action: 6,
            // }
            // EventManager.fire('gtm-event', eventStep6);

            if (paymentMethod ===
                this.selectedPaymentMethod) {
                return;
            }

            this.errors.payment = false;
            this.prevSelectedPaymentMethod = this.selectedPaymentMethod;
            this.selectedPaymentMethod = paymentMethod;

            this.handlePaymentMethodPromocode();

            this.selectedCard = null;

            if (paymentMethod.method === 'credit_card' && this.userCards.length > 1) {
                this.selectCard(this.userCards.filter(d => d.isPrimary === true)[0]);
            }

            let addPaymentInfo = {
                event: 'add_payment_info',
                cart: this.cart,
                eventData: paymentMethod,
            }

            EventManager.fire('gtm-event', addPaymentInfo);
        },
        selectCard(card) {
            if (card === this.selectedCard) {
                return;
            }
            this.selectedCard = card;
        },
        handlePaymentMethodPromocode() {
            if (this.shouldRemovePromocode()) {
                this.removePromocode();
            }

            if (this.shouldApplyPromocode()) {
                this.promocodeText = this.selectedPaymentMethod.promocode;
                this.applyPromocode();
            }
        },
        shouldApplyPromocode() {
            if (this.selectedPaymentMethod !== null && this.selectedPaymentMethod.promocode
                && (this.promocode === null
                    || (this.prevSelectedPaymentMethod !== null
                        && this.promocode.code === this.prevSelectedPaymentMethod.promocode)))
                return true;
            return false;
        },

        shouldRemovePromocode() {
            if (this.selectedPaymentMethod !== null && !this.selectedPaymentMethod.promocode && this.promocode && this.isPromocodeInPaymentMethods()) {

                return true;
            }
            return false;
        },

        isPromocodeInPaymentMethods() {
            let code = this.promocode.code;
            return this.selectedOption.paymentMethods.filter(p => p.promocode === code).length > 0;
        },
        syncPromocodeFromCart(cart) {
            this.hasPromocode = !!(cart && cart.promocode);
            this.promocode = cart?.promocode || null;
            this.promocodeText = cart?.promocode?.code || null;
        },
        cartUpdated(data) {
            const cart = parseCartResponse(data);
            if (!cart) {
                return;
            }

            this.cart = cart;
            this.syncPromocodeFromCart(cart);

            if (this.cart.rows.length === 0) {
                window.location.href = '/cart';
            }

            // Deselect Glovo if cart now contains non-fast shipping products
            if (this.selectedOption && this.selectedOption.id === 5 && this.hasNonFastShippingProducts) {
                this.selectedOption = null;
                this.selectedType = null;
                this.selectedPaymentMethod = null;
            }
        },
        cityChanged(data) {
            this.selectedCity = data;
            this.calcDeliveryPrice(this.deliveryPrice);
            this.validateEcontAddress();
        },

        isEcontAddressDelivery() {
            return this.selectedOption?.slug === 'econt_delivery_to_address'
                && !(this.hasUser && !this.allowNewAddress && this.selectedUserAddress);
        },

        getOrderAddressValue() {
            const el = this.$refs.orderAddressRaw;
            const field = el && el.length ? el[0] : el;

            return (field?.value ?? '').trim();
        },

        getOrderCityValue() {
            const el = this.$refs.cityField;
            const field = el && el.length ? el[0] : el;

            return field?.value || this.selectedCity || '';
        },

        /**
         * Resolves to false only when Econt explicitly rejected the address; request failures are left to the server-side check.
         */
        validateEcontAddress() {
            if (!this.validateEcontAddressUrl || !this.isEcontAddressDelivery()) {
                this.econtAddressError = null;
                return Promise.resolve(true);
            }

            const address = this.getOrderAddressValue();
            const city = this.getOrderCityValue();
            if (!address || !city) {
                return Promise.resolve(true);
            }

            const key = `${city}|${address}`;
            if (this.econtAddressValidatedKey === key) {
                return this.econtAddressRequest ?? Promise.resolve(!this.econtAddressError);
            }
            this.econtAddressValidatedKey = key;
            this.econtAddressValidating = true;
            const requestId = ++this.econtAddressRequestId;
            const isLatest = () => requestId === this.econtAddressRequestId;

            this.econtAddressRequest = new Promise((resolve) => {
                $.ajax({
                    url: this.validateEcontAddressUrl,
                    method: 'POST',
                    data: {city: city, address: address},
                })
                    .done((result) => {
                        if (isLatest()) {
                            this.econtAddressError = result.valid ? null : result.error;
                        }
                        resolve(!!result.valid || !isLatest());
                    })
                    .fail(() => {
                        if (isLatest()) {
                            this.econtAddressValidatedKey = null;
                        }
                        resolve(true);
                    })
                    .always(() => {
                        if (isLatest()) {
                            this.econtAddressValidating = false;
                            this.econtAddressRequest = null;
                        }
                    });
            });

            return this.econtAddressRequest;
        },

        resetEcontAddressValidation() {
            this.econtAddressRequestId++;
            this.econtAddressError = null;
            this.econtAddressValidating = false;
            this.econtAddressValidatedKey = null;
            this.econtAddressRequest = null;
        },

        toggleHaveInvoice() {
            this.haveInvoice = !this.haveInvoice & 1;
            // this.changeInvoice();
        },
        toggleRegisterMe() {
            this.registerMe = !this.registerMe & 1;
        },
        toggleSaveAddress() {
            this.saveAddress = !this.saveAddress & 1;
        },

        toggleNewAddressSelection() {
            this.allowNewAddress = !this.allowNewAddress & 1;
            this.selectedUserAddress = null;
            this.selectedOption = null;
            this.selectedType = null;
            // this.selectedArea = null;
            this.selectedCity = null;

            this.toggleSaveAddress();
        },


        preselectCity(city) {
            let select2 = $(this.$refs.cityField);
            let newOption = new Option(city.name, city.id, true, true);

            select2.append(newOption).trigger('change');
        },

        removeRow(row) {
            let _self = this;
            $.ajax({
                data: {id: row.id, haveInvoice: _self.haveInvoice},
                url: _self.removeRowUrl,
                method: 'POST',
                success: function (result) {
                    EventManager.fire('item-removed', result.cart);
                    let event = {
                        event: 'remove_from_cart',
                        eventData: result.variant,
                        action: 'CheckoutPage',
                    }
                    EventManager.fire('gtm-event', event);

                    let eventStep1 = {
                        event: 'eec.checkout',
                        eventData: 'Cart Page',
                        action: 1,
                        cart: JSON.parse(result.cart),
                    }

                    EventManager.fire('gtm-event', eventStep1);
                },
            });
        },
        changeInvoice() {
            let _self = this;
            $.ajax({
                data: {haveInvoice: _self.haveInvoice},
                url: _self.invoiceUrl,
                method: 'POST',
                success: function (result) {
                    EventManager.fire('cart-updated', result.cart);
                    // if (result.success !== false) {
                    //     _self.quantityAlert.visible = false;
                    // } else {
                    //     _self.quantityAlert.visible = true;
                    //     _self.quantityAlert.productName = row.name;
                    // }
                },
            });
        },
        addVariantQuantity(row) {
            let _self = this;
            $.ajax({
                data: {id: row.variantId, haveInvoice: _self.haveInvoice},
                url: _self.incrementUrl,
                method: 'POST',
                success: function (result) {
                    if (result.success !== false) {
                        _self.quantityAlert.visible = false;
                        EventManager.fire('item-added', result.cart);
                        EventManager.fire('cart-updated', result.cart);

                        let event = {
                            event: 'add_to_cart',
                            eventData: result.variant,
                            unique_event_id: result.unique_event_id,
                            action: 'CheckoutPage',
                            cart: result.cart
                        }
                        EventManager.fire('gtm-event', event);

                        // let eventStep1 = {
                        //     event: 'eec.checkout',
                        //     eventData: 'Cart Page',
                        //     action: 1,
                        //     cart: JSON.parse(result.cart),
                        // }
                        //
                        // EventManager.fire('gtm-event', eventStep1);
                    } else {
                        _self.quantityAlert.visible = true;
                        _self.quantityAlert.productName = row.name;
                    }
                },
            });
        },
        decrementVariantQuantity(row) {
            let _self = this;
            $.ajax({
                data: {id: row.id, haveInvoice: _self.haveInvoice},
                url: _self.decrementUrl,
                method: 'POST',
                success: function (result) {
                    _self.quantityAlert.visible = false;
                    EventManager.fire('item-removed', result.cart);

                    let event = {
                        event: 'remove_from_cart',
                        eventData: result.variant,
                        action: 'CheckoutPage',
                    }
                    EventManager.fire('gtm-event', event);


                    // let eventStep1 = {
                    //     event: 'eec.checkout',
                    //     eventData: 'Cart Page',
                    //     action: 1,
                    //     cart: JSON.parse(result.cart)
                    // }
                    //
                    // EventManager.fire('gtm-event', eventStep1);
                },
            });
        },

        incrementRowQuantity(row) {
            if (row.quantity > 99) {
                return;
            }
            this.addVariantQuantity(row);

        },

        decrementQuantity(row) {
            if (row.quantity === 1) {
                return;
            }
            this.decrementVariantQuantity(row);
        },
        formattedRowPrice(row) {
            return this.formattedPrice(row.quantity * row.price);
        },
        formattedPrice(price) {
            return new Intl.NumberFormat(this.locale, {style: 'currency', currency: this.currency}).format(price);
        },
        formattedDistance(distance) {
            return distance.toFixed(2) + 'КМ';
        },
        showMoreBoxNowOffices() {
            this.fetchPlaces(this.fetchBoxNowPlacesUrl, this.placeLat, this.placeLng, ++this.officesPage);
        },
        showMoreClickAndCollectPharmacies() {
            this.fetchPlaces(this.fetchClickAndCollectPharmaciesUrl, this.placeLat, this.placeLng, ++this.officesPage);
        },
        showMoreSpeedyOffices() {
            this.fetchPlaces(this.fetchSpeedyPlacesUrl, this.placeLat, this.placeLng, ++this.officesPage);
        },
        showMoreSamedayOffices() {
            this.fetchPlaces(this.fetchSamedayPlacesUrl, this.placeLat, this.placeLng, ++this.officesPage);
        },
        showMoreEcontOffices() {
            this.fetchPlaces(this.fetchEcontPlacesUrl, this.placeLat, this.placeLng, ++this.officesPage);
        },
        togglePromocodeField() {
            this.showPromocode = !this.showPromocode;
        },
        applyPromocode(event) {
            event.preventDefault();
            let _self = this;
            $.ajax({
                data: {code: _self.promocodeText, haveInvoice: _self.haveInvoice},
                url: _self.promocodeUrl,
                method: 'POST',
                success: function (result) {
                    if (result.success === false) {
                        _self.promocodeError = result.error;
                        return;
                    }

                    const cart = parseCartResponse(result);
                    if (!cart) {
                        return;
                    }

                    _self.promocodeError = null;
                    _self.cart = cart;
                    _self.syncPromocodeFromCart(cart);
                    EventManager.fire('cart-updated', serializeCartForEvent(cart));
                },
            });
        },

        removePromocode() {
            let _self = this;
            $.ajax({
                data: {haveInvoice: _self.haveInvoice},
                url: _self.removePromocodeUrl,
                method: 'POST',
                success: function (result) {
                    const cart = parseCartResponse(result);
                    if (!cart) {
                        return;
                    }

                    _self.cart = cart;
                    _self.syncPromocodeFromCart(cart);
                    EventManager.fire('cart-updated', serializeCartForEvent(cart));
                    _self.handlePaymentMethodPromocode();
                },
            });
        },

        qualifiesForFreeDelivery() {
            if (this.selectedOption && !this.selectedOption.allowFreeShipping) {
                return false;
            }
            if (this.hasPromocode && this.promocode.freeDelivery) {
                return true;
            }

            // Use different threshold for Glovo delivery (option.id == 5)
            if (this.selectedOption && this.selectedOption.id === 5) {
                this.freeDeliveryAmount = this.freeDeliveryOverGlovo;
            } else {
                this.freeDeliveryAmount = this.freeDeliveryOver;
            }

            return (this.cart.total >= this.freeDeliveryAmount) || this.cart.haveFreeDeliveryDiscount;
        },

        qualifiesForFreeDeliveryForOption(option) {
            if (!option.allowFreeShipping) {
                return false;
            }

            if (option.id === 5 && this.cart.total >= this.freeDeliveryOverGlovo) {
                return true;
            }

            if (this.hasPromocode && this.promocode.freeDelivery) {
                return true;
            }

            // Use different threshold for Glovo delivery (option.id == 5)
            let threshold = this.freeDeliveryOver;
            if (option.id === 5) {
                threshold = this.freeDeliveryOverGlovo;
            }

            return (this.cart.total >= threshold) || this.cart.haveFreeDeliveryDiscount;
        },

        calcDeliveryPrice(price) {
            // Use different threshold for Glovo delivery (option.id == 5)
            let threshold = this.freeDeliveryOver;
            if (this.selectedOption && this.selectedOption.id === 5) {
                threshold = this.freeDeliveryOverGlovo;
            }

            if (this.cart.total >= threshold) {
                return this.formattedPrice(0);
            } else {
                return this.formattedPrice(price);
            }
        },
        deliveryTypeHasDifferentPrices(type) {

            // if (type.areas.length === 1 && type.areas[0].options.length === 1) {
            //     return false;
            // }

            let price = type.options[0].price;
            let hasDifferentPrices = false;
            // type.areas.map(function (area) {
            //     area.options.map(function (option) {
            //         if (price !== option.price) {
            //             hasDifferentPrices = true;
            //         }
            //     })
            // })

            return hasDifferentPrices;

        },
        concatenateAttributeValues(attributes) {
            let str = '';
            for (let [index, attribute] of attributes.entries()) {
                if (index !== 0) {
                    str += ', '
                }
                if (attribute.showUnit) {
                    str += attribute.unit + ' x '
                }
                str += ' ' + attribute.value;

            }
            return str;
        },


        getAvailableMethods() {
            let methods = this.selectedOption.paymentMethods;

            // Filter out deleted methods (safety check - should already be filtered in backend)
            methods = methods.filter(pm => pm.deletedAt === null || pm.deletedAt === undefined);

            if (this.calcTotal(true) === 0) {
                methods = methods.filter(pm => pm.isFree === true);
            } else {
                methods = methods.filter(pm => pm.isFree === false);
            }

            // Filter out cash_on_delivery when cart total exceeds max amount (0 = no limit)
            const maxAmount = Number(this.cashOnDeliveryMaxAmount) || 0;
            if (maxAmount > 0) {
                const total = this.calcTotal(true);
                if (total > maxAmount) {
                    methods = methods.filter(pm => pm.method !== 'cash_on_delivery');
                }
            }

            if (methods.length === 1) {
                this.selectPaymentMethod(methods[0]);

            }
            return methods;
        },

        calcTotal(includeDelivery) {

            let total = this.cart.total;
            // if (this.selectedPackage) {
            //     total += this.selectedPackage.price;
            // }
            if (includeDelivery) {
                let deliveryPrice = this.deliveryPrice;

                if (this.hasPromocode) {
                    deliveryPrice = this.calcDeliveryAfterPromocode()
                    this.deliveryPriceDiscount = 0 - (this.deliveryPrice - deliveryPrice);
                }
                total += Number(deliveryPrice ?? 0);
            }
            total += this.computedCashOnDeliveryFee ?? 0;
            return Math.round(total * 100 + Number.EPSILON) / 100;
        },
        checkDeliveryPromocodeOption() {
            let _self = this;
            let result = false;

            this.promocode.deliveryPromocodeOptions.forEach(function (deliveryPromocodeOption, index) {
                if (deliveryPromocodeOption.isAvailable && deliveryPromocodeOption.optionId == _self.selectedOption.id) {
                    result = true;
                    return true;
                }
            });

            return result;
        },
        calcDeliveryAfterPromocode(price = null) {
            let computedPrice = this.deliveryPrice;

            if (price) {
                computedPrice = price;
            }

            if (!this.hasPromocode || !computedPrice || !this.promocode.deliveryDiscount) {
                return computedPrice;
            }

            const isPercentageType = this.promocode.deliveryDiscountType === 1;
            const isFixedType = this.promocode.deliveryDiscountType === 2;
            const invalidDeliveryType = !isFixedType && !isPercentageType;

            if (invalidDeliveryType) {
                console.warn('Invalid delivery discount type!', this.promocode.deliveryDiscountType);
                return computedPrice;
            }

            if (this.cart.quantity < this.promocode.deliveryDiscountProductsCountOver || this.cart.totalPriceAfterDiscount < this.promocode.deliveryDiscountPriceOver) {
                console.info('Skipping delivery discount – not all requirements are met!');
                return computedPrice;
            }

            if (isFixedType) {
                computedPrice = computedPrice - this.promocode.deliveryDiscount;
            } else if (isPercentageType) {
                computedPrice = computedPrice - (computedPrice * (this.promocode.deliveryDiscount / 100));
            }

            return computedPrice < 0 ? 0 : (computedPrice + Number.EPSILON).toFixed(2);
        },
        async revalidate(event) {
            this.$refs.checkoutForm.reportValidity();

            if (this.selectedOption && this.selectedOption.id === 5) {
                if (this.hasNonFastShippingProducts) {
                    this.errors.option = true;
                    return;
                }

                try {
                    const addressValue = this.searchTerm || this.selectedUserAddress.address;
                    if (!addressValue) {
                        this.errors.userAddress = true;
                        return;
                    }

                    if (!this.lat || !this.lng) {
                        this.locationError = "Моля изберете адрес от опциите в падащото меню";
                        this.errors.userAddress = true;
                        return;
                    }

                    this.selectedUserAddress = addressValue;

                    const glovoCoverage = await this.checkGlovoCoverage();
                    if (!glovoCoverage) {
                        this.errors.userAddress = true;
                        return;
                    }
                } catch (error) {
                    console.error('Error checking Glovo coverage:', error);
                    this.errors.userAddress = true;
                    return;
                }
            }

            if (this.hasUser && !this.allowNewAddress && !this.selectedUserAddress) {
                this.errors.userAddress = true;
                return;
            }
            if (!this.selectedType) {
                this.errors.type = true;
                return;
            }
            if (!this.selectedOption) {
                this.errors.option = true;
                return;
            }
            if (!this.selectedPaymentMethod) {
                this.errors.payment = true;
                return;
            }

            if (!(await this.validateEcontAddress())) {
                const el = this.$refs.orderAddressRaw;
                const field = el && el.length ? el[0] : el;
                field?.scrollIntoView({behavior: 'smooth', block: 'center'});
                field?.focus();
                return;
            }

            this.syncCheckoutHiddenFields();
            this.$refs.checkoutForm.submit();
        },
        syncCheckoutHiddenFields() {
            const form = this.$refs.checkoutForm;
            const setByName = (name, value) => {
                const field = form?.querySelector(`[name="${name}"]`);
                if (field) {
                    field.value = value ?? '';
                }
            };

            setByName('order[orderAddress][selectedOfficeId]', this.selectedOffice?.id ?? '');
            setByName('order[orderAddress][samedayLocationIds]', this.samedayLocationIds ?? '');
            setByName('order[orderAddress][samedayCityName]', this.samedayCityName ?? '');
            setByName('order[orderAddress][samedayPostalCode]', this.samedayPostalCode ?? '');
            setByName('order[orderAddress][deliveryOption]', this.selectedOption?.id ?? '');
            setByName('order[deliveryOption]', this.selectedOption?.id ?? '');

            const addressEl = this.$refs.orderAddressRaw;
            const addressValue = addressEl?.value ?? addressEl?.[0]?.value ?? '';
            setByName('order[orderAddress][address]', addressValue);

            const cityEl = this.$refs.cityField;
            const cityValue = cityEl?.value ?? cityEl?.[0]?.value ?? '';
            if (cityValue) {
                setByName('order[orderAddress][city]', cityValue);
            }

            const selectedOfficeField = this.$refs.selectedOfficeIdField;
            const officeInput = Array.isArray(selectedOfficeField) ? selectedOfficeField[0] : selectedOfficeField;
            if (officeInput && this.selectedOffice?.id) {
                officeInput.value = this.selectedOffice.id;
            }
        },
        async checkGlovoCoverage() {
            // Use the structured address details
            const details = this.glovoAddressDetails
            if (!details) {
                this.errors.userAddress = true;
                return { covered: false, error: 'No address details available' };
            }

            try {
                const response = await fetch('/ajax/check-glovo-coverage', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        addressDetails: details,
                    })
                });
                const data = await response.json();
                return data;
            } catch (error) {
                console.error('Error checking Glovo coverage:', error);
                this.errors.userAddress = true;
                return { covered: false, error: error.toString() };
            }
        },
        hasValidationErrors(type) {
            return this.errors[type];

        },
        getHolidaysForDeliveryType(deliveryOptionSlug) {
            const globalHolidays = JSON.parse(this.holidays || '[]');
            const dayOffsBySlug = JSON.parse(this.dayOffsBySlug || '{}');

            const slugToTypeGroupMapping = {
                'click_and_collect': ['click_and_collect'],
                'boxnow_delivery_to_station': ['boxnow_delivery_to_station'],
                'speed_delivery_to_address': ['speed_delivery_to_address', 'speed_delivery_to_office'],
                'speed_delivery_to_office': ['speed_delivery_to_address', 'speed_delivery_to_office'],
            };

            const possibleSlugs = slugToTypeGroupMapping[deliveryOptionSlug] || [deliveryOptionSlug];
            const dayOffDates = [];
            if (possibleSlugs.length > 0) {
                possibleSlugs.forEach(slug => {
                    if (dayOffsBySlug[slug]) {
                        dayOffDates.push(...dayOffsBySlug[slug]);
                    }
                });
            }

            return [...new Set([...globalHolidays, ...dayOffDates])];
        },

        getDeliveryDateLabel(option) {
            const now = new Date();
            const currentHour = now.getHours();
            const deliveryOptionSlug = option.deliveryType.slug;

            const holidays = this.getHolidaysForDeliveryType(deliveryOptionSlug);
            function addWorkingDays(date, days, holidays) {
                let result = new Date(date);
                while (days > 0) {
                    result.setDate(result.getDate() + 1);
                    if ([6, 0].includes(result.getDay())) continue;
                    if (holidays.includes(result.toISOString().slice(0, 10))) continue;
                    days--;
                }
                return result;
            }

            const monthsBg = ['януари', 'февруари', 'март', 'април', 'май', 'юни', 'юли', 'август', 'септември', 'октомври', 'ноември', 'декември'];
            const daysBg = ['Неделя', 'Понеделник', 'Вторник', 'Сряда', 'Четвъртък', 'Петък', 'Събота'];
            function formatBgDate(date) {
                const dayName = daysBg[date.getDay()];
                const day = date.getDate();
                const month = monthsBg[date.getMonth()];
                return `${dayName}, ${day} ${month}`;
            }

            let resultDate;
            switch (deliveryOptionSlug) {
                case 'click_and_collect':
                    if (currentHour < 16) {
                        resultDate = addWorkingDays(now, 1, holidays);
                    } else {
                        resultDate = addWorkingDays(now, 2, holidays);
                    }
                    break;
                case 'speed_delivery_to_office':
                case 'speed_delivery_to_address':
                    if (currentHour < 14) {
                        resultDate = addWorkingDays(now, 1, holidays);
                    } else {
                        resultDate = addWorkingDays(now, 2, holidays);
                    }
                    break;
                case 'glovo_on_demand':
                    resultDate = addWorkingDays(now, 0, holidays);
                    break;
                case 'boxnow_delivery_to_station':
                    // Weekend handling
                    if ([6, 0].includes(now.getDay())) {
                        let sofiaDate = addWorkingDays(now, 1, holidays);
                        let sofiaLabel = `За София - ${formatBgDate(sofiaDate)}`;

                        // Non-Sofia: next working day after Sofia's date
                        let nonSofiaDate = addWorkingDays(sofiaDate, 1, holidays);
                        let nonSofiaLabel = `${formatBgDate(nonSofiaDate)}`;
                        return sofiaLabel + '<br> За страната - ' + nonSofiaLabel;
                    } else {
                        // Weekday handling
                        if (currentHour < 14) {
                            // Before 14:00 - Sofia: same day, Non-Sofia: next working day
                            let sofiaDate = now;
                            let sofiaLabel = `За София - ${formatBgDate(sofiaDate)}`;
                            let nonSofiaDate = addWorkingDays(now, 1, holidays);
                            let nonSofiaLabel = `${formatBgDate(nonSofiaDate)}`;
                            return sofiaLabel + '<br> За страната - ' + nonSofiaLabel;
                        } else {
                            // After 14:00 - Sofia: next working day, Non-Sofia: 2 working days
                            let sofiaDate = addWorkingDays(now, 1, holidays);
                            let sofiaLabel = `За София - ${formatBgDate(sofiaDate)}`;
                            let nonSofiaDate = addWorkingDays(now, 2, holidays);
                            let nonSofiaLabel = `${formatBgDate(nonSofiaDate)}`;
                            return sofiaLabel + '<br> За страната - ' + nonSofiaLabel;
                        }
                    }
                    break;
                default:
                    resultDate = addWorkingDays(now, 1, holidays);
            }
            return formatBgDate(resultDate);
        },
        initGlovoAutocomplete() {
            if (this.glovoAutocompleteInstance) return;
            if (!window.google || !window.google.maps) return;

            const input = this.getGlovoAutocompleteField();
            if (!input) return;

            this.glovoAutocompleteInstance = this.initGoogleMapsApiAutocomplete(input, null);
        },
        isGlovoOutOfWorkingHours(hour, minutes) {
            return (hour <= 8 && minutes <= 30) || (hour >= 16 && minutes > 20);
        },
    },

    computed: {
        econtAddressFieldClass() {
            return {'is-invalid': !!this.econtAddressError};
        },
        formattedTotal() {
            if (this.qualifiesForFreeDelivery()) {
                return this.formattedPrice(this.calcTotal(false))
            }

            return this.formattedPrice(this.calcTotal(true))
        },
        computedDeliveryPrice() {
            if (this.qualifiesForFreeDelivery()) {
                return 0;
            }
            let computedPrice = this.deliveryPrice;
            if (this.hasPromocode) {
                computedPrice = this.calcDeliveryAfterPromocode()
            }
            return computedPrice;
        },

        computedCashOnDeliveryFee() {
            if (this.selectedPaymentMethod != null
                && (this.selectedPaymentMethod.method === "cash_on_delivery"
                    || this.selectedPaymentMethod.method === "cash_on_courier"
                    || this.selectedPaymentMethod.method === "credit_card_on_courier"))
                return this.initialCashOnDeliveryFee;
            return 0;
        },
        formattedOriginalTotal() {
            return this.formattedPrice(this.cart.originalTotal)
        },
        amountToFreeShipping() {
            let threshold = this.freeDeliveryOver;
            if (this.selectedOption && this.selectedOption.id === 5) {
                threshold = this.freeDeliveryOverGlovo;
            }
            return this.formattedPrice(threshold - this.cart.total);
        },

        amountToFreeGlovoShipping() {
            const threshold = this.freeDeliveryOverGlovo;
            const amountNeeded = threshold - this.cart.total;
            return amountNeeded > 0 ? this.formatDualPrice(amountNeeded) : null;
        },
        formattedDiscount() {
            return '-' + this.formattedPrice(this.cart.discount);
        },
        formattedLoyaltyProgramDiscount() {
            return '-' + this.formattedPrice(this.cart.loyaltyProgramDiscount);
        },
        formattedPromocodeDiscount() {
            return '-' + this.formatDualPrice(this.cart.totalPromocodeDiscount);
        },
        formattedDiscountWithoutPromocode() {
            return '-' + this.formattedPrice(this.cart.discount);
        },

        hasNonFastShippingProducts() {
            if (!this.cart || !this.cart.rows) return false;
            return this.cart.rows.some(row => !row.fastShipping);
        },

        isWeekendRestrictedTime() {
            // Friday 16h to Monday 9h

            const now = this.getGlovoNow();
            const day = now.getDay();
            const hours = now.getHours();
            const minutes = now.getMinutes();
            const currentTime = hours * 60 + minutes;

            if (day === 5 && currentTime >= 960) {
                return true;
            }

            if (day === 6) {
                return true;
            }

            if (day === 0) {
                return true;
            }

            if (day === 1 && currentTime < 540) {
                return true;
            }

            return this.isGlovoOutOfWorkingHours(hours, minutes);
        }
    }
});
